export default [
  {
    name: '巡检管理',
    svgIcon: require('leo-assets/audit.svg'),
    rightKey: 'audit',
    path: 'audit',
    children: [
      {
        name: '待审核-基站',
        rightKey: 'to-audit',
        path: 'to-audit',
        svgIcon: require('leo-assets/wait-audit.svg'),
      },
      {
        name: '待审核-室分',
        rightKey: 'to-audit-shifen',
        path: 'to-audit-shifen',
        svgIcon: require('leo-assets/wait-audit.svg'),
      },
      {
        name: '集团审核-室分',
        rightKey: 'second-review-shifen',
        path: 'second-review-shifen',
        svgIcon: require('leo-assets/check.svg'),
      },
      {
        name: '基站定位稽查',
        svgIcon: require('leo-assets/police.svg'),
        rightKey: 'record',
        path: 'record',
      },
      {
        name: '所有巡检记录',
        rightKey: 'all-audit',
        path: 'all-audit',
        svgIcon: require('leo-assets/batch-inspection.svg'),
      },

      {
        name: '基站巡检历史',
        rightKey: 'station',
        path: 'station',
        svgIcon: require('leo-assets/base-station.svg'),
      },

      // {
      //   name: '批次',
      //   rightKey: 'batch',
      //   path: 'batch',
      //   svgIcon: require('leo-assets/batch-inspection.svg'),
      // },
    ],
  },
  {
    name: '批次管理',
    svgIcon: require('leo-assets/batch-management.svg'),
    rightKey: 'batch-management',
    path: 'batch-management',
  },
  {
    name: '外部组管理',
    svgIcon: require('leo-assets/group.svg'),
    rightKey: 'external-group-management',
    path: 'external-group-management',
  },
  {
    name: '用户管理',
    svgIcon: require('leo-assets/group.svg'),
    rightKey: 'user-manager',
    path: 'user-manager/staff-list',
  },
  {
    name: '巡检汇总',
    svgIcon: require('leo-assets/statistics.svg'),
    rightKey: 'summary',
    path: 'summary',
    children: [
      {
        name: '公司汇总',
        svgIcon: require('leo-assets/company.svg'),
        rightKey: 'company-summary',
        path: 'company',
      },
      {
        name: '部门汇总',
        svgIcon: require('leo-assets/department.svg'),
        rightKey: 'department-summary',
        path: 'department',
      },
    ],
  },
  {
    name: '尽调项目',
    svgIcon: require('leo-assets/decode.svg'),
    rightKey: 'due-diligence',
    path: 'due-diligence',
    children: [
      {
        name: '全部',
        rightKey: 'all-due-diligence',
        path: 'all-due-diligence',
        svgIcon: require('leo-assets/all.svg'),
      },
      {
        name: '待审核',
        rightKey: 'pending-review',
        path: 'pending-review',
        svgIcon: require('leo-assets/wait-audit.svg'),
      },
      {
        name: '集团审核',
        rightKey: 'second-review',
        path: 'second-review',
        svgIcon: require('leo-assets/check.svg'),
      },
      {
        name: '附件待上传',
        rightKey: 'pending-upload',
        path: 'pending-upload',
        svgIcon: require('leo-assets/wait-audit.svg'),
      },
      {
        name: '项目尽调完成情况',
        svgIcon: require('leo-assets/company.svg'),
        rightKey: 'project-summary',
        path: 'project-summary',
      },
      {
        name: '项目尽调基站明细',
        svgIcon: require('leo-assets/base-station.svg'),
        rightKey: 'station-details',
        path: 'station-details',
      },
    ],
  },
  {
    name: '巡检附件',
    svgIcon: require('leo-assets/inspection-attachment.svg'),
    rightKey: 'inspection-attachment',
    path: 'inspection-attachment/my-list',
  },
];
